export var EAnalyticsActionType = /*#__PURE__*/function (EAnalyticsActionType) {
  EAnalyticsActionType["FillIn"] = "fill_in";
  return EAnalyticsActionType;
}({});
export var EAnalyticsConstant = /*#__PURE__*/function (EAnalyticsConstant) {
  EAnalyticsConstant["Error"] = "\u0427\u0442\u043E-\u0442\u043E \u043F\u043E\u0448\u043B\u043E \u043D\u0435 \u0442\u0430\u043A";
  return EAnalyticsConstant;
}({});